import axios from 'axios';

export const api = axios.create({ timeout: 40 * 1000 });

export const isB2BEnabled = process.env.NEXT_PUBLIC_B2B_ENABLE === 'true';
